// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".last-item-group .device-ip{font-size:14px;position:relative;text-decoration:none;top:-7px}.last-item-group .server-icon{padding-right:10px}.last-item-group .server-icon img{width:70px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
